import { application } from '@core/controllers/app';

application.register('dtfs-admin--account-setups--notifications-form',
  require('./dtfs_admin/account_setups/notifications_form_controller').default);

application.register('dtfs-admin--account-setups--stripe-platform-form',
  require('./dtfs_admin/account_setups/stripe_platform_form_controller').default);

application.register('dtfs-admin--account-setups--hpp-locale-configurations-form',
  require('./dtfs_admin/account_setups/hpp_locale_configurations_form_controller').default);

application.register('dtfs-admin--audit-trails',
  require('./dtfs_admin/audit_trails_controller').default);
